export default __webpack_public_path__ + "static/media/488.033ec61d.png";